
import { useSelector } from "react-redux";

const usePageSettings = () => {
    const pageSettings = useSelector((state) => state.pageSettings);
    return pageSettings;
};

export default usePageSettings;